// extracted by mini-css-extract-plugin
module.exports = {"layoutIcon":"_3SbgV","fillBlue":"_3HDHC","strokeBlue":"_8M7x5","fillWhite":"_19gc1","strokeWhite":"_3S4ka","active":"_2DeEc"};